<template>
<v-card class="panel" elevation="1">
    <div class="subscriptions">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">
                    <inertia-link :href="'/backoffice/members/details/'+ member.id +'/subscriptions/'" class="name">
                    <v-icon color="#921E61" class="mb-1">mdi-arrow-left-circle</v-icon>
                    {{ $page.props.lang.memberships || "Memberships" }}
                    </inertia-link>
                     / {{ membership.subscription.name }} 
                     <v-chip v-if="membership.status == 0" class="ml-2" color="warning" text-color="white" stlyle="top:12px; right:6px;"> <v-icon class="mr-1" style="padding-bottom: 0.4px" small color="white">mdi-cancel</v-icon> {{ $page.props.lang.canceled || "Canceled"}} </v-chip>
                     <v-chip v-else-if="membership.paused" class="ml-2" color="warning" text-color="white" stlyle="top:12px; right:6px;"> <v-icon class="mr-1" style="padding-bottom: 0.4px; font-size:18px" small color="white">mdi-pause-circle-outline</v-icon> {{ $page.props.lang.paused || "Paused"}} </v-chip>
                     </h2>
            </div>
            <div class="right" v-show="$page.props.p['members.manage']">
                <v-btn color="primary" dark @click="openCancelModal(membership.id)" v-if="membership.status == 1">
                    <v-icon small>mdi-cancel</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2"> {{ $page.props.lang.cancel || "Cancel"}} </span>
                </v-btn>
                <v-btn color="primary" dark @click="openDeleteModal(membership.id)" v-if="membership.can_delete">
                    <v-icon small style="font-size:17px;">mdi-trash-can-outline</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.delete || "Delete"}}</span>
                </v-btn>
                <v-btn color="primary" dark @click="pauseModal = true" v-if="!membership.paused && membership.status == 1">
                    <v-icon style="font-size:18px;" small>mdi-pause-circle-outline</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.pause || "Pause"}}</span>
                </v-btn>
                <v-btn color="primary" dark @click="pauseMembership(false)" v-if="membership.paused">
                    <v-icon style="font-size:18px;" small>mdi-play-circle-outline</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.activate || "Activate"}}</span>
                </v-btn>
                <EditMembership :membership="membership" :courses="courses"></EditMembership>
            </div>
            </div>
            <div class="container">
                <v-row>
                    <v-col cols="6">
                        <p>{{ $page.props.lang.startDate || "Start date"}}: {{ membership.start_date | formatDate}}</p>
                        <p>{{ $page.props.lang.endDate || "End date"}}: {{ membership.final_end_date }}</p>
                        <p>{{ $page.props.lang.price || "Price"}}: {{ membership.subscription.price }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span>/{{membership.subscription.period_value}} {{membership.subscription.period_name}}</p>
                    </v-col>
                    <v-col cols="6">
                        <div v-if="membership.is_limited">
                            <p>{{$page.props.lang.allowed_activites || "Allowed Activites"}}</p>
                            <v-chip class="mr-2" v-for="course in membership.courses" v-bind:key="course.id">{{course.title}}</v-chip>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <div class="renew-btn">
                <v-btn v-if="membership.status !== 0" color="primary" dark outlined @click="renewModal = true">
                    <v-icon small style="font-size:17px;">mdi-autorenew</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.renew || "Renew"}}</span>
                </v-btn>
            </div>

            <v-dialog v-model="renewModal" max-width="500px" content-class="new-subscription">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.renewMembership || "Renew membership" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="renewModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <label class="custom-label">{{ $page.props.lang.title ||'Membership'}}</label>  
                                <v-text-field :value="membership.subscription.name" outlined dense solo flat disabled></v-text-field>
                            </v-col>
                            <div class="wrap-hidden" style="margin-top:0px">
                            <v-col cols="12">
                                 <label class="custom-label">{{ $page.props.lang.startDate || 'Start Date' }}</label>
                                    <v-menu
                                    class="fit"
                                    v-model="startDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="newPeriod.start_date | formatDate" 
                                            append-icon="mdi-menu-down" readonly v-bind="attrs" v-on="on" 
                                            @click:append="startDatePicker = true" outlined dense
                                            :error-messages="responseErrors.start_date"
                                            @focus="responseErrors.start_date=''"
                                            :hide-details="!responseErrors.start_date"></v-text-field>
                                        </template>
                                        <v-date-picker 
                                        v-model="newPeriod.start_date" 
                                        :first-day-of-week="1" no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="startDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="startDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <label class="custom-label">{{ $page.props.lang.price || 'Price' }}</label>
                                <v-text-field 
                                    v-model="membership.mem_price" type="number" :suffix="$page.props.organization.settings.currency" 
                                    outlined dense solo flat disabled hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch v-model="newPeriod.limit_sessions" :label="$page.props.lang.limitSessions || 'Limit Sessions'"></v-switch>
                                    <label v-if="newPeriod.limit_sessions" class="custom-label">{{ $page.props.lang.limit || 'Total Sessions' }}</label>
                                    <v-text-field v-if="newPeriod.limit_sessions" 
                                            v-model="newPeriod.total_sessions" type="number" 
                                            outlined dense solo flat
                                            :error-messages="responseErrors.total_sessions"
                                            @focus="responseErrors.total_sessions=''"
                                            :hide-details="!responseErrors.total_sessions"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                <v-switch v-model="newPeriod.is_paid" 
                                    v-show="$page.props.p['members.payments.make']"
                                    :label="$page.props.lang.markAsPaid || 'Mark as paid'"></v-switch>
                                <label v-if="newPeriod.is_paid" class="custom-label">{{ $page.props.lang.paymentMethod || 'Payment type' }}</label>
                                <v-select v-if="newPeriod.is_paid"
                                    class="fit"
                                    v-model="newPeriod.pay_method"
                                    :items="paymentTypes"
                                    item-text="name"
                                    item-value="id"
                                    :error-messages="responseErrors.pay_method"
                                    @focus="responseErrors.pay_method=''"
                                    :hide-details="!responseErrors.pay_method"
                                    outlined dense>
                                </v-select>
                                </v-col>
                            </div>    
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="regular" @click="renewModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn color="primary" :loading="addingPeriod" @click="addPeriod">{{ $page.props.lang.renew || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
            </v-dialog>

            <div class="table-container">
            <v-data-table
                :headers="subscriptionsHeaders"
                :items="membership.periods"
                :page.sync="tablePage"
                :items-per-page="itemsPerPage"
                @page-count="tablePageCount = $event"
                item-key="item.id"
                mobile-breakpoint="0"
                hide-default-footer>
                <template v-slot:item.start_date="{ item }">
                    <a href="javascript:void(0)" @click="openPaymentModal(item.id)"
                    v-show="$page.props.p['members.manage']">
                        {{item.start_date | formatDate }} - {{ item.end_date | formatDate}}
                    </a>  
                </template>
                <template v-slot:item.limit="{ item }">
                    <span v-if="!item.limited_visits">∞</span>
                    <span v-else> {{ item.remaining_visits }} / {{ item.total_visits}} </span>
                </template>
                <template v-slot:item.is_paid="{ item }">
                    <v-chip v-if="item.is_paid == 0" class="ml-2" color="red" text-color="white" stlyle="top:12px; right:6px;" small> 
                    <v-icon class="mr-2" small color="white">mdi-currency-usd-off</v-icon>
                    {{ $page.props.lang.unpaid || "Unpaid"}} 
                    </v-chip>
                    <v-chip v-else class="ml-2" color="#4ede77" text-color="white" stlyle="top:12px;" small> 
                    <v-icon class="mr-1" small color="white">mdi-currency-usd</v-icon>
                    {{ $page.props.lang.paid || "Paid"}} 
                    </v-chip>
                </template>
                <template v-slot:item.action="{ item }">  
                    <v-btn @click="openUpdatePeriodModal(item)" :id="'update' + item.id" v-show="$page.props.p['members.manage']" icon>
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip :activator="'#update'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.edit_period || "Edit period"}}</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn v-if="item.is_paid == 0" @click="openPaymentModal(item.id)" :id="'payment' + item.id" v-show="$page.props.p['members.payments.make']" icon>
                        <v-icon>mdi-cash-multiple</v-icon>
                        <v-tooltip :activator="'#payment'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.addPayment || "Add Payment"}}</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn @click="openDeletePeriodModal(item)" 
                        :id="'delete' + item.id" 
                        v-show="$page.props.p['members.manage']"
                        color="red"
                        icon>
                        <v-icon>mdi-delete</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.deletePeriod || "Remove period"}}</span>
                        </v-tooltip>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
   
        <v-dialog v-model="pauseModal" max-width="450px">
            <v-card>
                 <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.pauseMembership || "Pause membership" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="pauseModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                      <div class="fields">
                        <div class="grid">
                        <p>{{ $page.props.lang.pausedMembershipDesc || "Paused membership will be extended for the number of days it was paused. During this time, the customer will not be able to book new appointments.You can activate the membership at any time." }}</p>
                        <p>{{ $page.props.lang.pauseMembershipUntil || "Pause membership until:" }}</p>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field 
                                    v-model="date" 
                                    append-icon="mdi-menu-down" outlined dense readonly v-bind="attrs" v-on="on" 
                                    @click:append="menu = true" class="birth-date"
                                ></v-text-field>
                            </template>
                            <v-date-picker 
                                v-model="date" 
                                :min="tommorow" 
                                :first-day-of-week="1" no-title scrollable color="primary">
                                <v-spacer></v-spacer>
                                    <v-btn color="regular" @click="menu = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                    <v-btn color="primary" @click="$refs.menu.save(date)">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                        </div>        
                      </div>
                      <v-card-actions>                     
                         <v-btn absolute right @click="pauseMembership(true)" color="primary" class="mb-4 mr-2">{{ $page.props.lang.pauseMembership || "Pause membership" }}</v-btn>
                      </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

      <ConfirmModal 
        :open="deleteSubModal"
        @close="deleteSubModal = false"
        :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
        :description="$page.props.lang.confirm_delete_membership || 'Are you sure you want to delete this membership? If you delete it, it will not be included in reports.'" 
        @no="deleteSubModal = false" 
        @yes="deleteMemberSubscription"
      >
      </ConfirmModal>

      <ConfirmModal 
        :open="deletePeriodModal"
        @close="deletePeriodModal = false"
        :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
        :description="this.membership.periods.length > 1 ? $page.props.lang.confirm_delete_membership_period || 'If you delete it, related payment will not be deleted. Payment can be manually deleted on Payments page.' 
        : $page.props.lang.confirm_delete_last_membership_period || 'If you delete this period, membership will be deleted also. Related payment will not be deleted. Payment can be manually deleted on Payments page.'" 
        @no="deletePeriodModal = false" 
        @yes="deletePeriod"
      >
      </ConfirmModal>

      <ConfirmModal 
      :open="cancelSubModal"
      @close="cancelSubModal = false"
      :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
      :description="$page.props.lang.confirm_cancel_membership || 'Are you sure you want to cancel this membership?'"
      @no="cancelSubModal = false" 
      @yes="cancelMemberSubscription"
      >
      </ConfirmModal>

      <PaymentModal v-if="PaymentModal"
        :modal="PaymentModal"
        :member_id="member.id"
        :period_id="this.currentPeriodId"
        :payment_types="this.paymentTypes"
        @close="PaymentModal = false">
        </PaymentModal>

        <UpdatePeriodModal v-if="updatePeriodModal" :open="updatePeriodModal" :period="currentPeriod"></UpdatePeriodModal>
        
    </div>
    </v-card>
    <!-- <v-card v-else class="mx-auto my-12" max-width="500" outlined>
            <v-card-text v-html="$page.props.lang.no_active_periods || 'No added subscription.'" class="text-center "></v-card-text>
    </v-card> -->
</template>

<style scoped>
  .v-select.fit {
    width: 250px !important;
  }
</style>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import ConfirmDelete from '@/js/Components/ConfirmDelete'
import ConfirmModal from '@/js/Components/ConfirmModal'
import PaymentModal from '@/js/Components/PaymentModal'
import UpdatePeriodModal from './Components/UpdatePeriodModal'
import Label from '../../../Jetstream/Label.vue'
import EventBus from '@/js/eventbus'
import EditMembership from '@/js/Pages/Backoffice/Members/Components/EditMembership'


export default {
    metaInfo() {
        return {
            title: this.$page.props.member.full_name + ' - ' + (this.$page.props.lang.title || "Subscription")
        }
    },
	name: "MemberSubscriptionDetails",
	components: {
		ConfirmDelete,
        ConfirmModal,
        PaymentModal,
        UpdatePeriodModal,
        EditMembership
	},
      layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
        member: Object,
        membership: Object,
        paymentTypes: Array,
        courses: Array,
        errors: Object,
        lang: Object
    },
	data() {
		return {
            date: moment(this.membership.periods[0].end_date).add(1, 'days').format('YYYY-MM-DD'),
            // date: null,
            subscriptionsHeaders: [
                {text: this.lang.period || 'Date Range', value: 'start_date', sortable: false, align: 'start'},
                {text: this.lang.limit || 'Limit', value: 'limit', sortable: false, align: 'left'},
                {text: this.lang.status || 'Status', value: 'is_paid', sortable: false, align: 'center'},
                {value: 'action', sortable: false, align: 'end'},
               
            ],
            updatePeriodModal: false,
            messageObjects: [],
            responseErrors: {},
            deletePeriodModal: false,
            // paymentModal: false,
            period:[],
            currentPeriodId:null,
            PaymentModal:false,
            tablePage: 1,
            tablePageCount: 0,
            itemsPerPage: 8,
            payment: {},
            currentPeriod: null,
            deleteSubModal: false,
            cancelSubModal: false,
            subForDeleteId: null,
            subForCancelId: null,
            pauseModal: false,
            menu: false,
            tommorow:  moment().add(1,'days').format('YYYY-MM-DD'),
            activePicker: null,
            pauseUntilDate: null,
            renewModal: false,
            startDatePicker: false,
            startEndDatePicker: false,
            newPeriod:{
                start_date: moment(this.membership.periods[0].end_date).add(1, 'days').format('YYYY-MM-DD'),
                member_id: this.member.id,
                membership_id: this.membership.id,
                limit_sessions: this.membership.limit_sessions,
                total_sessions: this.membership.total_sessions,
                is_paid: false,
                pay_method: null
            },
            addingPeriod:false
            
		}
	},
   
    created(){
        EventBus.$on('CLOSE_PAYMENT_MODAL', (p) => {

            this.$inertia.reload()
            this.PaymentModal = false;
        });

        EventBus.$on('CLOSE_UPDATE_PERIOD_MODAL', (x) => {

            if(x && x.reload){
                this.$inertia.reload({ only: ['membership'] });
            }
            
            this.updatePeriodModal = false;
        })
    },

    watch: {
        
        member: function (value) {
            this.memberData = value
        },
        membership: function(value){
           
            this.newPeriod.start_date = moment(value.periods[0].end_date).add(1, 'days').format('YYYY-MM-DD');    
        }
    },
    methods: {
        paymentAvailable(item) {
            if (item.is_paid===0) {
                return true
            }
        },
        openPaymentModal(period_id) {
            this.currentPeriodId = period_id;
            this.PaymentModal = true;
                    
        },

        assignPayment() {
            axios.post('/backoffice/members/assignPayment', this.payment)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.paymentModal = false
                        this.$inertia.reload()
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        this.paymentModal = false
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        addPeriod(){
            this.addingPeriod = true;
            axios.post('/backoffice/members/addPeriod', this.newPeriod)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.reload();
                        this.addingPeriod = false;
                        this.renewModal = false;
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        
                    }
                })
                .catch(error => {
                    this.addingPeriod = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        openUpdatePeriodModal(item){

            this.currentPeriod = item;

            
            this.updatePeriodModal = true;

        },
       
        pauseMembership(pause){
            let pausePack = {
                pause: pause,
                member_id: this.member.id,
                membership_id: this.membership.id,
                paused_until: this.date,
            }
            axios.post('/backoffice/members/membership/pause', pausePack)
                .then(response => {
                    var color = "error"
                    if(response.data.status==="OK") {
                        color = "success"
                        this.$inertia.reload()
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                     this.pauseModal = false
                    }
                })
        },

        openDeleteModal(subscription_id){
            this.deleteSubModal = true
            this.subForDeleteId = subscription_id
        },

        openDeletePeriodModal(item){
            this.deletePeriodModal = true
            this.period_id = item.id
        },

        deletePeriod() {
            axios.post('/backoffice/members/deletePeriod', {'member_id': this.member.id, 'id': this.period_id, 'membership_id': this.membership.id})
                .then(response => {
                    var color = "success"

                    if(response.data.status == "OK"){
                        this.deletePeriodModal = false;
                        this.$inertia.reload({only: ['membership']});
                  
                    }else{
                        color = "error" 
                    }
                    EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: color,
                                timeout: 5000
                            })        
                })
                .catch(error => {
                    
                });

        },

        deleteMemberSubscription(){
           let deleteMembSubPack = {
                member_id: this.member.id,
                id: this.subForDeleteId
            }
            axios.post('/backoffice/members/deleteSubscription', deleteMembSubPack)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.visit('/backoffice/members/details/'+ this.member.id + '/subscriptions')
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        this.deleteSubModal = false
                    }
                })
                .catch(function(error) {                
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
            this.deleteSubModal = false
        },

        openCancelModal(membership_id){
            this.cancelSubModal = true
            this.subForCancelId = membership_id
        },

        cancelMemberSubscription(){
            let cancelMembSubPack = {
                member_id: this.member.id,
                id: this.subForCancelId
            }
            axios.post('/backoffice/members/cancelMembership', cancelMembSubPack)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.reload()
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        this.cancelSubModal = false
                    }
                })
                .catch(function(error) {                
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
            this.cancelSubModal = false
            
        }
    },
    
}
</script>